var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16H16.0001C16.0001 15.9857 16.0001 15.9717 16.0001 15.9572C15.9858 15.9715 15.9716 15.9858 15.9573 16Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9857 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.08691C5.5921 3.51185 3.51167 5.59223 2.08679 8.09466V16H6.26073V6.26098V6.26085H15.9999C15.9999 4.94441 15.9999 3.69029 15.9999 2.08691H8.09454Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 14.0325L10.3154 8.3479H8.3479V8.34803L16 16H16.0001C16.0001 16 16.0001 14.6433 16.0001 14.0325V14.0325Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0585 18.3421C27.5186 17.7091 27.8259 16.9361 27.8259 16V9.04346C27.2445 9.48022 26.522 9.73909 25.739 9.73909C24.6011 9.73909 23.5909 9.19265 22.9564 8.3479C22.3217 9.19265 21.3115 9.73909 20.1737 9.73909C19.3906 9.73909 18.6681 9.48015 18.0868 9.04359V16C18.0868 16.9361 18.3941 17.7091 18.8542 18.3421H27.0585Z",
    fill: "#F3F3F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.612 14.7095C25.8335 14.1691 26.0057 13.3793 26.0057 12.9862C26.0057 12.3547 25.1823 11.8427 25.1823 11.8427C25.1823 11.8427 24.359 12.3547 24.359 12.9862C24.359 13.3793 24.5313 14.1692 24.7527 14.7095L24.2773 15.7827C24.5567 15.8963 24.8621 15.9594 25.1824 15.9594C25.5027 15.9594 25.808 15.8962 26.0875 15.7827L25.612 14.7095Z",
    fill: "#FF9811"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3936 11.2345C21.8151 11.3129 21.0449 11.5588 20.7045 11.7553C20.1576 12.0711 20.1259 13.0401 20.1259 13.0401C20.1259 13.0401 20.981 13.4971 21.5279 13.1814C21.8684 12.9848 22.4661 12.4408 22.8232 11.9788L23.9904 11.8538C23.9491 11.5552 23.8509 11.2591 23.6909 10.9818C23.5307 10.7045 23.3235 10.4715 23.0854 10.2863L22.3936 11.2345Z",
    fill: "#FF9811"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9935 15.7592C21.3505 16.2209 21.9485 16.7648 22.289 16.9615C22.8359 17.2772 23.691 16.8203 23.691 16.8203C23.691 16.8203 23.6591 15.8512 23.1123 15.5354C22.7717 15.3388 22.0017 15.0932 21.423 15.0149L20.7314 14.0666C20.4933 14.2517 20.286 14.4848 20.1259 14.7619C19.9658 15.0393 19.8678 15.3353 19.8263 15.6341L20.9935 15.7592Z",
    fill: "#FF9811"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6823 18.0872C19.9815 20.1718 22.9566 20.8697 22.9566 20.8697C22.9566 20.8697 25.9316 20.1718 27.2309 18.0872H18.6823Z",
    fill: "#338AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.e4e3aceb.svg";
export { ForwardRef as ReactComponent };